export default "__VITE_ASSET__DlY88Ani__"